import styled from 'styled-components';
import { mq, getSpace, getFixedSpace, getTransition } from '../../../stylesheets/tools';

const StyledArchiveHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${getSpace('140px')} ${getFixedSpace('m')} 0;
  overflow: hidden;
  position: relative;
  width: 100%;

  ${mq('m')} {
    overflow: visible;
    padding-top: ${getSpace('xxxl')};
  }

  .archive-header__link {
    margin-top: ${getSpace('m')};
    display: flex;
    align-items: center;
    gap: ${getSpace('xxs')};

    svg {
      ${getTransition('defaultFast')}
    }

    &:hover,
    &:focus {
      svg {
        transform: translateX(-4px);
      }
    }
  }

  .archive-header__background {
    position: absolute;
    top: 0;
    right: 0;
    z-index: -100;
    height: 140px;
    width: 100vw;
    transition: all 0.4s ease;

    ${mq('m')} {
      width: 50vw;
      height: 200px;
    }

    svg {
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
`;

export default StyledArchiveHeader;
